import { defineMessages } from "react-intl"

export const ecommerceItemLabelMessages = defineMessages({
    "first_name": {
        id: "ecommerce.components.ecommerce_items.first_name_label",
        defaultMessage: "First Name",
    },
    "last_name": {
        id: "ecommerce.components.ecommerce_items.last_name_label",
        defaultMessage: "Last Name",
    },
    "phone": {
        id: "ecommerce.components.ecommerce_items.phone_label",
        defaultMessage: "Phone",
    },
    "email": {
        id: "ecommerce.components.ecommerce_items.email_label",
        defaultMessage: "Email",
    },
    "company": {
        id: "ecommerce.components.ecommerce_items.company_label",
        defaultMessage: "Company",
    },
    "notes": {
        id: "ecommerce.components.ecommerce_items.notes_label",
        defaultMessage: "Notes",
    },
    "shipping_address": {
        id: "ecommerce.components.ecommerce_items.shipping_address_label",
        defaultMessage: "Shipping Address",
    },
    "billing_address": {
        id: "ecommerce.components.ecommerce_items.billing_address_label",
        defaultMessage: "Billing Address",
    },
    "shipping_address-field-street": {
        id: "ecommerce.components.ecommerce_items.shipping_street_label",
        defaultMessage: "Street",
    },
    "shipping_address-field-street2": {
        id: "ecommerce.components.ecommerce_items.shipping_street_2_label",
        defaultMessage: "Street 2",
    },
    "shipping_address-field-city": {
        id: "ecommerce.components.ecommerce_items.shipping_city_label",
        defaultMessage: "City",
    },
    "shipping_address-field-zip": {
        id: "ecommerce.components.ecommerce_items.shipping_zip_label",
        defaultMessage: "Zip",
    },
    "shipping_address-field-province": {
        id: "ecommerce.components.ecommerce_items.shipping_province_label",
        defaultMessage: "Province",
    },
    "shipping_address-field-country": {
        id: "ecommerce.components.ecommerce_items.shipping_country_label",
        defaultMessage: "Country",
    },
    "billing_address-field-street": {
        id: "ecommerce.components.ecommerce_items.billing_street_label",
        defaultMessage: "Street",
    },
    "billing_address-field-street2": {
        id: "ecommerce.components.ecommerce_items.billing_street_2_label",
        defaultMessage: "Street 2",
    },
    "billing_address-field-city": {
        id: "ecommerce.components.ecommerce_items.billing_city_label",
        defaultMessage: "City",
    },
    "billing_address-field-zip": {
        id: "ecommerce.components.ecommerce_items.billing_zip_label",
        defaultMessage: "Zip",
    },
    "billing_address-field-province": {
        id: "ecommerce.components.ecommerce_items.billing_province_label",
        defaultMessage: "Province",
    },
    "billing_address-field-country": {
        id: "ecommerce.components.ecommerce_items.billing_country_label",
        defaultMessage: "Country",
    },
})

export const ecommerceTypeLabelMessages = defineMessages({
    "string": {
        id: "ecommerce.components.ecommerce_items.string_type",
        defaultMessage: "String",
    },
    "text-area": {
        id: "ecommerce.components.ecommerce_items.text_area_type",
        defaultMessage: "Text Area",
    },
    "address": {
        id: "ecommerce.components.ecommerce_items.address_type",
        defaultMessage: "Address",
    },
    "single-choice": {
        id: "ecommerce.components.ecommerce_items.single_choice_type",
        defaultMessage: "Single Choice",
    },
    "image": {
        id: "ecommerce.components.ecommerce_items.image_type",
        defaultMessage: "Image",
    },
    "date": {
        id: "ecommerce.components.ecommerce_items.date_type",
        defaultMessage: "Date",
    },
    "multi-line-text": {
        id: "ecommerce.components.ecommerce_items.multi_line_text_type",
        defaultMessage: "Text Area",
    },
})


// WEBPACK FOOTER //
// ./src/settings/ecommerce/messages/EcommerceItemMessages.ts